<template>
  <div>
    <div style="margin-top: 40px; margin-left: 0">
      <div style="width: 465px; margin-bottom: 20px; position: relative">
        <div style="display: table-cell; width: 70px" v-if="apienabled">
          <el-icon
            style="
              font-size: 30px;
              color: #26c39e;
              position: absolute;
              left: 20px;
            "
            ><Check
          /></el-icon>

          <div style="display: table-cell; padding: 8px 0 0 70px">
            {{ messages.apistatus[store.langSelect.value] }}
          </div>
        </div>
      </div>
      <div
        style="width: 465px; margin-bottom: 20px; position: relative"
        class="lk_content_info_block"
      >
        <div style="display: table-cell; width: 70px">
          <el-icon
            style="
              font-size: 30px;
              position: absolute;
              transform: rotate(180deg);
              left: 20px;
              color: #e82862;
            "
            ><Warning
          /></el-icon>
        </div>
        <div style="display: table-cell" v-html="messages.apiinfo[store.langSelect.value]">
          
        </div>
      </div>

      <Button
        :text="
          apienabled
            ? messages.apiDisableSend[store.langSelect.value]
            : messages.apiSend[store.langSelect.value]
        "
        @click="Send"
      />
    </div>
    <div style="margin-top: 20px">
      <a :href="apiSpecUrl" target="_blank">{{
        messages.apiSpec[store.langSelect.value]
      }}</a>
    </div>
    <div style="margin-top: 20px">
      <a :href="apiExamplesUrl" target="_blank">{{
        messages.apiExamples[store.langSelect.value]
      }}</a>
    </div>
    <div style="margin-top: 50px"></div>
    <div
        style="width: 465px; margin-bottom: 20px; position: relative"
        class="lk_content_info_block"
      >
        <div style="display: table-cell; width: 70px">
          <el-icon
            style="
              font-size: 30px;
              position: absolute;
              transform: rotate(180deg);
              left: 20px;
              color: #e82862;
            "
            ><Warning
          /></el-icon>
        </div>
        <div style="display: table-cell" v-html="messages.apiinfoPort[store.langSelect.value]">
        </div>
      </div>
  </div>
  <ServiceHistoryTable>
    <template v-slot:mtthead="">
      <div class="th">Date</div>
      <div class="th"></div>
    </template>
    <template v-slot:mttbody="props">
      <div class="tr" v-show="props.item.Service == 'api'">
        <div class="td">{{ getStringTime(props.item.Date) }}</div>
        <div class="td">Заявка на "{{ props.item.HistoryInfo.sub }}"</div>
      </div>
    </template>
  </ServiceHistoryTable>
</template>
<script>
import { useMyStorage } from "@/store/global";

import Button from "@/components/Button";
import axios from "axios";
import { Warning, Check } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { ref, watch } from "vue";
import ServiceHistoryTable from "./ServiceHistotyTable";
export default {
  name: "ApiComponent",
  components: {
    Button,
    Warning,
    Check,
    ServiceHistoryTable,
  },
  setup() {
    const store = useMyStorage();
    const disabledButton = ref(true);
    const apienabled = ref(false);
    const ips = ref({});
    const apiSpecUrl = "https://ae.exchange/docs/ClientAPI.pdf";
    const apiExamplesUrl = "https://ae.exchange/docs/test_client_api.py";

    watch(
      () => store.AccountsFullData,
      () => {
        CheckMany();
      },
      { deep: true }
    );
    const CheckMany = () => {
      const accFull = store.AccountsFullData.value;

      console.log(store.AccountsFullData);
      console.log("000000000000000000000");
      accFull.forEach((element) => {
        console.log(element.Money);
      });
    };
    const GetStatus = () => {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + store.token.value;
      axios
        .post(store.ServerUrl + "/users/api/status", null)
        .then(function (resp) {
          console.log(resp);
          if (resp.data.code === 0) {
            const data = JSON.parse(resp.data.msg);
            apienabled.value = data.apienabled;
            ips.value = data.IP;
            console.log(data["apienabled"]);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    };
    const SetIP = () => {
      let data = {
        IPs: ips.value,
        Delete: false,
      };
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + store.token.value;
      axios
        .post(store.ServerUrl + "/users/api/ip", data)
        .then(function (resp) {
          console.log(resp);
        })
        .catch(function (err) {
          console.log(err);
        });
    };
    const Send = () => {
      let accounts = store.GetAllAccountsToString();
      let sub = "Подключение";
      if (apienabled.value) {
        sub = "Отключение";
      }
      let body =
        "Заявка на услуги: Client API \r\n ЛК " +
        store.serverConf[store.currentServer].name +
        "\r\n e@mail: " +
        store.userInfo.value.Roles.email +
        "\r\n  счета клиента: " +
        accounts +
        "\r\n услуга: " +
        sub;
      let data = {
        To: "client@ae.exchange",
        Subject: "Заявка на услуги: Client API",
        Body: body,
      };
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + store.token.value;
      axios
        .post(store.ServerUrl + "/users/sendtelegram", data)
        .then(function (resp) {
          console.log(resp);
        })
        .catch(function (err) {
          console.log(err);
        });

      let info =
        "{'service':'Client API', 'sub':'" +
        sub +
        "', 'login':'" +
        store.userInfo.value.Name +
        "'}";
      let shis = {
        service: "api",
        accounts: accounts,
        email: store.userInfo.value.Roles.email,
        status: "pending",
        historyinfo: info,
      };
      axios
        .post(store.ServerUrl + "/users/savesevicehistory", shis)
        .finally(() => {
          store.LoadServiceHistory(accounts);
        });
      ElMessage({
        type: "success",
        message: "Заявка отправлена",
      });
    };
    const getStringTime = (dt) => {
      const ts = new Date(dt);
      // console.log(val)
      console.log("++++++++++" + ts + "----------");

      return (
        ts.getUTCFullYear() +
        "-" +
        pad(ts.getUTCMonth() + 1) +
        "-" +
        pad(ts.getUTCDate()) +
        " " +
        pad(ts.getUTCHours()) +
        ":" +
        pad(ts.getUTCMinutes()) +
        ":" +
        pad(ts.getUTCSeconds())
      );
    };
    const pad = (n) => {
      return n < 10 ? "0" + n : n;
    };
    GetStatus();
    // CheckMany();
    //SetIP();
    const messages = {
      apistatus: ["Подключена"],
      apiinfo: [
        "Для получения доступа к API AE отправьте заявку на подключение. <br/>" +
          "Внимание! Доступ предоставляется при наличии на счете не менее 1000 USDT или эквивалент в BTC и др. активах.",
      ],
      apiinfoPort:["Для подключения по API используется файл сертификата от десктоп терминала. <br/><br/> Адрес подключения: 213.219.228.50 <br/> Порт подключения: 21300 "],
      IP: [],
      apiSend: ["Заявка на подключение"],
      apiDisableSend: ["Заявка на отключение"],
      apiExamples: ["Пример клиентского API-протокола"],
      apiSpec: [
        "Спецификация протокола подключения к бирже  client api websocket",
      ],
    };
    return {
      apiSpecUrl,
      apiExamplesUrl,
      store,
      Send,
      SetIP,
      disabledButton,
      messages,
      ips,
      apienabled,
      getStringTime,
    };
  },
};
</script>
